import { createContext, useContext } from "react";
import { YearStep } from "app/pages/InteractiveProposal/YearStepper";

export type IRCLockState = "pre_window" | "fee_locked" | "unlocked";

interface IRCContextValue {
  lockState: IRCLockState;
  reviewOpenDate: string | null;
  calendarYear: number;
  isContact: boolean;
  onPayNow: () => void;
  refreshSummary: () => void;
  yearSteps: YearStep[];
  selectedYear: number;
  selectedCreditType: string;
}

export const IRCContext = createContext<IRCContextValue>({
  lockState: "unlocked",
  reviewOpenDate: null,
  calendarYear: new Date().getFullYear(),
  isContact: false,
  onPayNow: () => {},
  refreshSummary: () => {},
  yearSteps: [],
  selectedYear: 1,
  selectedCreditType: "preCredit",
});

export const useIRCContext = () => useContext(IRCContext);
